export const SET_SETTING_RSVP = 'SETTING/SET_SETTING_RSVP'
